// Kept apart from Reports.jsx so the sidebar and home page can import these
// lists without loading the Reports page (and its Excel libraries).

// ── Who sees what ────────────────────────────────────────────────────────────
// admin, asmaa, abdelrhman, acountant-1 see every report; Agent and Yara also
// see Missing Enrollment Letters; the Rush report has its own list.
export const ALL_REPORT_USERS = ["admin", "asmaa", "abdelrhman", "acountant-1"];
// Top Achievers Event Invitation page: the report users plus alaa.
export const INVITATION_USERS = [...ALL_REPORT_USERS, "alaa", "agent5"];
// Top Achievers Photos page. Mirrors PHOTOS_USERS in
// Server/src/components/top_achievers_photos/photos.routes.js.
export const PHOTOS_USERS = ["admin", "abdelrhman", "asmaa"];
export const MISSING_ENROLLMENT_USERS = [...ALL_REPORT_USERS, "Agent", "agent", "Yara"];
// Mirrors RUSH_REPORT_USERS in Server/src/components/student/student.routes.js.
export const RUSH_REPORT_USERS = ["admin", "asmaa", "abdelrhman", "agent", "Agent", "agent5"];
// Mirrors CERTIFICATE_RECEIVERS_REPORT_USERS (+ admin role) in student.routes.js.
export const CERTIFICATE_RECEIVERS_USERS = [...ALL_REPORT_USERS, "alaa", "agent5", "agent", "Agent"];

// Mirrors the /invoice/bank_transfer/report route in student.routes.js.
export const BANK_TRANSFER_REPORT_USERS = ["admin", "asmaa", "abdelrhman", "acountant-1"];

export const REPORT_USERS = Array.from(
  new Set([...MISSING_ENROLLMENT_USERS, ...RUSH_REPORT_USERS, ...CERTIFICATE_RECEIVERS_USERS])
);
